import PointLayer from "./PointLayer";

export default class OrganizationLayer extends PointLayer {
    constructor(map, data, options = {}) {
        super(map, data, 'Organization', options = {scale: 0.2});
        this.mapTooltip = null;
    }

    handlerNode(node, info) {
        node.s({
            'interactive': false,
            '2d.selectable': false,
            '3d.selectable': false,
            // 'texture.cache': true,
            'shape3d.image': `symbols/smart-park/map/${info.type}.json`
        });
        node.a('name', info.name);
    }

    showLayer() {
        super.show();
    }

    hideLayer() {
        super.hide();
    }

}